// @ts-nocheck
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { URL } from '../../service/Service';
import { useI18n } from '../../i18n/I18nContext';


const phoneCountries = [
    {
        code: '+351',
        label: 'Portugal',
        flag: '🇵🇹',
        placeholder: '9XXXXXXXX',
        pattern: '[0-9]{9}',
        maxLength: 9,
        hint: 'Introduza os 9 algarismos do número português.',
    },
    {
        code: '+34',
        label: 'Espanha',
        flag: '🇪🇸',
        placeholder: '6XXXXXXXX',
        pattern: '[0-9]{9}',
        maxLength: 9,
        hint: 'Introduza os 9 algarismos do número espanhol.',
    },
    {
        code: '+39',
        label: 'Itália',
        flag: '🇮🇹',
        placeholder: '3XXXXXXXXX',
        pattern: '[0-9]{6,11}',
        maxLength: 11,
        hint: 'Introduza entre 6 e 11 algarismos do número italiano.',
    },
];


const MBWay = ({
                   value,
                   formReplies,
                   fixedValue,
                   itemPurchases,
                   donations,
                   email,
                   onEmailChange,
               }) => {

    const { t } = useI18n();

    const [alias, setAlias] = useState('');
    const [countryCode, setCountryCode] = useState('+351');
    const [error, setError] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const navigate = useNavigate();


    const paymentErrorMessage =
        'Não foi possível iniciar o pagamento com MB WAY. Tente novamente ou escolha outro método.';

    const paymentUnavailableMessage =
        'MB WAY não está disponível para este formulário. Por favor, selecione outro método de pagamento.';


    const selectedCountry =
        phoneCountries.find(
            country => country.code === countryCode
        )
        || phoneCountries[0];


    /*
     * Identifica a resposta do backend quando
     * o método não está disponível no canal.
     */
    const isPaymentMethodUnavailable = (
        responseStatus,
        responseText,
        result,
    ) => {

        if (responseStatus === 503) {
            return true;
        }

        const rawMessage = [
            responseText,
            result?.message,
            result?.error,
            result?.detail,
        ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();

        return (
            rawMessage.includes('método de pagamento selecionado não está disponível')
            || rawMessage.includes('metodo de pagamento selecionado nao esta disponivel')
            || rawMessage.includes('método de pagamento não está disponível')
            || rawMessage.includes('metodo de pagamento nao esta disponivel')
            || rawMessage.includes('payment method unavailable')
            || rawMessage.includes('paymentmethodunavailable')
        );
    };


    const handleFetch = async () => {

        if (isSubmitting || !isChecked) {
            return;
        }

        const normalizedEmail =
            String(email || '').trim();

        if (!normalizedEmail) {

            setError(
                'Introduza o seu email.'
            );

            return;
        }


        /*
         * Validar número de telefone conforme
         * o país selecionado.
         */
        const phoneRegex =
            new RegExp(
                `^${selectedCountry.pattern}$`
            );


        if (!phoneRegex.test(alias)) {

            setError(
                selectedCountry.hint
            );

            return;
        }


        setIsSubmitting(true);
        setError('');


        try {

            const body = {

                value,

                alias,

                countryCode,

                email: normalizedEmail,

                fixedValue,

                itemPurchases,

                donations,

                formID: formReplies.formID,

                replyFields: formReplies.replyFields,

                /*
                 * IP público obtido no FormReader.
                 */
                ip: formReplies?.ip || '',

            };


            const response = await fetch(
                `${URL}/api/payment/mbway`,
                {
                    method: 'POST',

                    headers: {
                        accept: 'application/json',
                        'content-type': 'application/json',
                    },

                    body: JSON.stringify(body),
                }
            );


            const responseText =
                await response.text();


            let result = {};


            if (responseText) {

                try {

                    result =
                        JSON.parse(responseText);

                } catch (_error) {

                    result = {};

                }
            }


            /*
             * =====================================================
             * MB WAY NÃO DISPONÍVEL
             * =====================================================
             */
            if (
                !response.ok
                && isPaymentMethodUnavailable(
                    response.status,
                    responseText,
                    result,
                )
            ) {

                setError(
                    paymentUnavailableMessage
                );

                return;
            }


            /*
             * Outros erros.
             */
            if (!response.ok) {

                setError(
                    paymentErrorMessage
                );

                return;
            }


            /*
             * Resposta válida.
             */
            navigate(
                '/clientforms/success/mbw',
                {
                    state: {
                        paymentinfo: result,
                        formId: formReplies.formID,
                    },
                }
            );


        } catch (_error) {

            setError(
                paymentErrorMessage
            );

        } finally {

            setIsSubmitting(false);

        }
    };


    return (

        <div className="mt-5">

            {/* ===================================================
          EMAIL
          =================================================== */}
            <label
                htmlFor="email-mbway"
                className="mb-2 block text-sm font-bold"
                style={{
                    color: 'var(--form-text)',
                }}
            >
                Email
            </label>


            <input
                id="email-mbway"
                type="email"
                name="email-mbway"
                autoComplete="email"
                placeholder="Insira o seu Email"
                required
                value={email || ''}
                onChange={onEmailChange}
                disabled={isSubmitting}
                className="
          block
          w-full
          rounded-xl
          border
          border-gray-300
          bg-white
          p-2.5
          text-sm
          text-gray-900
          outline-none
          transition
          focus:border-green-cl
          focus:ring-2
          focus:ring-green-cl/20
          disabled:cursor-not-allowed
          disabled:opacity-60
        "
                style={{
                    backgroundColor: '#ffffff',
                    color: '#111827',
                }}
            />


            {/* ===================================================
          TELEFONE
          =================================================== */}
            <label
                htmlFor="mbway-phone"
                className="mb-2 mt-5 block text-sm font-bold"
                style={{
                    color: 'var(--form-text)',
                }}
            >
                Número de Telefone
            </label>


            <div className="flex w-full">

                <select
                    value={countryCode}
                    disabled={isSubmitting}
                    onChange={(event) => {

                        setCountryCode(
                            event.target.value
                        );

                        setAlias('');

                        setError('');
                    }}
                    className="
            w-[138px]
            shrink-0
            rounded-l-xl
            border
            border-r-0
            px-3
            py-2.5
            text-sm
            font-semibold
            outline-none
            focus:ring-2
            focus:ring-green-cl/20
            disabled:cursor-not-allowed
            disabled:opacity-60
          "
                    style={{
                        color: 'var(--form-text)',
                        backgroundColor: 'var(--form-surface)',
                        borderColor: 'var(--form-border)',
                    }}
                >

                    {
                        phoneCountries.map(country => (

                            <option
                                key={country.code}
                                value={country.code}
                            >
                                {country.flag} {country.code}
                            </option>

                        ))
                    }

                </select>


                <input
                    id="mbway-phone"
                    type="tel"
                    value={alias}
                    placeholder={selectedCountry.placeholder}
                    maxLength={selectedCountry.maxLength}
                    inputMode="numeric"
                    disabled={isSubmitting}
                    onChange={(event) => {

                        setAlias(
                            event.target.value.replace(
                                /\D/g,
                                ''
                            )
                        );

                        if (error) {
                            setError('');
                        }
                    }}
                    className="
            min-w-0
            flex-1
            rounded-r-xl
            border
            px-4
            py-2.5
            text-sm
            outline-none
            focus:ring-2
            focus:ring-green-cl/20
            disabled:cursor-not-allowed
            disabled:opacity-60
          "
                    style={{
                        color: 'var(--form-text)',
                        backgroundColor: 'var(--form-surface)',
                        borderColor: 'var(--form-border)',
                    }}
                />

            </div>


            <small
                className="mt-2 block text-sm"
                style={{
                    color: 'var(--form-muted)',
                }}
            >
                {t(selectedCountry.label)}: {t(selectedCountry.hint)}
            </small>


            {/* ===================================================
          CONSENTIMENTO
          =================================================== */}
            <label
                htmlFor="mbway-consent"
                className="
          mt-6
          flex
          cursor-pointer
          items-start
          gap-3
          rounded-xl
          border
          p-4
          text-sm
        "
                style={{
                    color: 'var(--form-text)',
                    borderColor: 'var(--form-border)',
                    background: 'var(--form-surface)',
                }}
            >

                <input
                    id="mbway-consent"
                    type="checkbox"
                    checked={isChecked}
                    disabled={isSubmitting}
                    onChange={(event) =>
                        setIsChecked(
                            event.target.checked
                        )
                    }
                    className="
            mt-0.5
            h-4
            w-4
            rounded
            border-gray-300
            text-green-cl
            focus:ring-green-cl
            disabled:cursor-not-allowed
            disabled:opacity-60
          "
                />


                <span>
          Tomei conhecimento que a informação constante deste formulário é guardada e tratada pela Eupago e dou consentimento para tal.
        </span>

            </label>


            {/* ===================================================
          ERRO / MÉTODO INDISPONÍVEL
          =================================================== */}
            {error && (

                <div
                    role="alert"
                    className="
            mt-4
            rounded-xl
            border
            border-red-200
            bg-red-50
            p-4
          "
                >

                    <p
                        className="
              text-sm
              font-semibold
              text-red-700
            "
                    >
                        {error}
                    </p>

                </div>

            )}


            {/* ===================================================
          FINALIZAR
          =================================================== */}
            <div className="flex justify-end">

                <button
                    type="button"
                    onClick={handleFetch}
                    disabled={
                        !isChecked
                        || isSubmitting
                        || !String(email || '').trim()
                        || !alias
                    }
                    className="
            mt-6
            inline-flex
            w-full
            items-center
            justify-center
            rounded-xl
            bg-green-cl
            px-5
            py-3
            font-semibold
            text-white
            transition
            hover:bg-opacity-90
            disabled:cursor-not-allowed
            disabled:opacity-50
          "
                >

                    {
                        isSubmitting
                            ? 'A processar...'
                            : 'Finalizar'
                    }

                </button>

            </div>

        </div>
    );
};


export default MBWay;